<script setup>
  import { ref, reactive, computed, onMounted, defineComponent, defineExpose, defineEmits } from 'vue'
  import { userInfoStore, rewardListStore } from '@/stores/counter.js'
  import { showToast } from 'vant';
  import { getReqData, getHomeConfigAPI, loginoutAPI, getCommunicationAPI, sendGiftCodeAPI } from '@/util/api'
  
  // import lottie from 'lottie-web'
  // import homeJson from "@/assets/img/Homepag.json"
  // import homeJson from "@/assets/img/boxerLottie.json"
  // import homeJson from "@/assets/img/ICON.json"

  // const ElementLottie = defineComponent(Lottie)
  // const startLaunch = (anim) => {
  //   anim.setSpeed(1.5);
  //   anim.play();
  // }
  const emit = defineEmits(['needLogin', 'goPayPage', 'goBinding', 'goNextPage'])
  const goLogin = () => {
    emit('needLogin');
  }
  const goPay = () => {
    emit('goPayPage')
  }
  const goNext = () => {
    emit('goNextPage')
  }

  const userStore = userInfoStore()
  const rewardStore = rewardListStore()
  const userInfo = computed(() => {
    return userStore.userInfo
  })
  const configData = ref('')
  const showBindingGifPop = ref(false)
  const showBindingGifPop2 = ref(false)
  const communication = ref('')
  const bingdingEmail = ref('')
  const noPlay = ref(true)

  const toAppStor = () => {
    window.location.href = configData.value.download[1].value
  }
  const toGgStor = () => {
    window.location.href = configData.value.download[0].value
  }
  const toFb = () => {
    window.location.href = configData.value.download[2].value
  }
  const toNaver = () => {
    window.location.href = 'https://cafe.naver.com/hllcmt'
  }

  const getHomeConfig = () => {
    getHomeConfigAPI().then(res => {
      if (res.data.code == 0) {
        console.log('【首页配置】', res.data.data);
        configData.value = res.data.data
        localStorage.setItem('config-record', JSON.stringify(res.data.data))
      } else {
        showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }
  const loginout = () => {
    loginoutAPI(getReqData({})).then(res => {
      if (res.data.code == 0) {
        showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
        userStore.setUserInfo('')
        localStorage.removeItem('2G19fZeORY8=')
        localStorage.removeItem('FiJISxKHfpo=')
      } else {
        showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }
  const getCommunication = () => {
    let reqData = {
      pgid: 59,
      uid: userInfo.value.uid,
      uname: userInfo.value.uname,
      token: userInfo.value.token
    }
    getCommunicationAPI(getReqData(reqData)).then(res => {
      if (res.data.code == 0) {
        console.log('【用户绑定信息】', res.data.data);
        communication.value = res.data.data
        bingdingEmail.value = communication.value.email.replace(
        /(\d{3})\d*(\d{2})/,
        "$1****$2"
      );
      } else {
        showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }
  const claimGif = () => {
    if (!userInfo.value) {
      goLogin()
      return
    }
    if (communication.value.email) {
      showBindingGifPop2.value = true
    } else {
      showBindingGifPop.value = true
    }
    
  }
  const goBD = () => {
    emit('goBinding')
  }
  const sendGiftCode = () => {
    let reqData = {
      uname: userInfo.value.uname,
      uid: userInfo.value.uid,
      token: userInfo.value.token,
      pgid: 59,
      pid: 45,
      gid: 1000796,
      rid: 310,
      email: communication.value.email
    }
    sendGiftCodeAPI(getReqData(reqData)).then(res => {
      if (res.data.code == 0) {
        showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
        showBindingGifPop2.value = false
      } else {
        showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }
  const palyAudio = () => {
    if (document.getElementById('audioHome')) {
      document.getElementById('audioHome').play()
      noPlay.value = false
    }
  }
  const stopAudio = () => {
    if (document.getElementById('audioHome')) {
      document.getElementById('audioHome').pause()
      noPlay.value = true
    }
  }

  defineExpose({ getCommunication, stopAudio, palyAudio })
  onMounted(() => {
    getHomeConfig()
    if (userInfo.value) {
      getCommunication()
    }
    // lottie.loadAnimation({
    //   container: document.getElementById('imgWrapper'),
    //   renderer: 'html',
    //   loop: true,
    //   autoplay: true,
    //   animationData: homeJson,
    // })
  })
</script>

<template>
  <section class="content-box" @click="palyAudio">
    <video
      src="@/assets/img/01p/home.mp4"
      poster="@/assets/img/01p/xg-bac.jpg"
      :autoplay="true"
      loop="loop"
      muted="muted"
      crossorigin="anonymous"
      :playsinline="true"
      style="width: 100%; height: 100%; object-fit: cover;"
    >
    </video>
    <section class="yy-box">
      <section style="display: flex; justify-content: center; align-items: flex-end;">
        <!-- <img v-if="configData" :src="configData.download[4].value" alt="" style="height: 1.96rem;"> -->
        <!-- <aside style="display: flex; flex-direction: column; align-items: center; margin: 0px 12px;">
          <img src="@/assets/img/01p/btn0101.png" alt="" style="height: 0.9rem; margin-bottom: 0.08rem;"> -->
          <img src="@/assets/img/01p/btn0102.png" alt="" @click="goPay" style="width: 2.84rem;">
        <!-- </aside>
        <aside style="display: flex; flex-direction: column; align-items: center;"> -->
          <img src="@/assets/img/01p/btn0201.png" alt="" @click="toAppStor" style="width: 2.6rem; margin: 0rem 0.42rem;">
          <img src="@/assets/img/01p/btn0202.png" alt="" @click="toGgStor" style="width: 2.6rem;">
        <!-- </aside> -->
      </section>
      <aside @click="goNext" style="height: 0.84rem; display: flex;">
        <img class="jiantou" src="@/assets/img/01p/jt-icon.png" alt="">
      </aside>
    </section>
    <aside class="side-left">
      <img src="@/assets/img/01p/fb-icon.png" alt="" @click="toFb" style="height: 0.92rem; margin-bottom: 0.42rem;">
      <img v-if="!(communication.email && communication.giftcode.email == 1)" src="@/assets/img/01p/gif-icon.png" alt="" @click="claimGif" style="height: 0.92rem; margin-bottom: 0.42rem;">
      <img src="@/assets/img/01p/naver-icon.png" alt="" @click="toNaver" style="height: 0.92rem;">
    </aside>
    <aside class="side-right">
      <img src="@/assets/img/01p/xz.png" alt="" style="height: 0.22rem; margin-bottom: 0.1rem;">
      <img v-if="configData" :src="configData.download[4].value" alt="" style="width: 1.36rem; margin-bottom: 0.2rem;">
      <img src="@/assets/img/01p/btn0201.png" alt="" @click="toAppStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <img src="@/assets/img/01p/btn0202.png" alt="" @click="toGgStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <img src="@/assets/img/01p/pay-btn.png" alt="" @click="goPay" style="height: 0.45rem;">
    </aside>
    <aside v-if="userInfo" class="out-box">
      <span style="margin-right: 6px;">{{ userInfo.uname }}</span>
      <button class="out-btn" @click="loginout">로그아웃</button>
    </aside>
    <img v-else src="@/assets/img/01p/login-btn.png" alt="" @click="goLogin" style="position: absolute; right: 0.24rem; top: 1.2rem; height: 0.36rem;">
    <aside class="audio-btn">
      <img v-if="noPlay" @click="palyAudio" src="@/assets/img/01p/audio-btn1.png" alt="" style="width: 0.5rem;">
      <img v-else @click.stop="stopAudio" src="@/assets/img/01p/audio-btn2.png" alt="" style="width: 0.5rem;">
    </aside>
    <section class="mask-box" v-if="showBindingGifPop">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 36px; width: 100%;">
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showBindingGifPop = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <img src="@/assets/img/04p/lq-title.png" alt="" style="height: 27px; margin-top: 24px;">
        <img src="@/assets/img/04p/send-tips.png" alt="" style="width: 394px; margin: 42px 0px 32px;">
        <!-- <span style="font-size: 20px; margin: 12px 0px 32px;">{{ '메일 연동:' + bdEmail }}</span> -->
        <aside style="display: flex; justify-content: center; align-items: center;">
          <img src="@/assets/img/04p/config-btn.png" alt="" @click="goBD" style="height: 60px; margin-right: 25px;">
          <img src="@/assets/img/04p/close-btn.png" alt="" @click="showBindingGifPop = false" style="height: 60px; margin-left: 25px;">
        </aside>
      </section>
    </section>
    <section class="mask-box" v-if="showBindingGifPop2">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 36px; width: 100%;">
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showBindingGifPop2 = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <img src="@/assets/img/04p/lq-title.png" alt="" style="height: 27px; margin-top: 24px;">
        <img src="@/assets/img/04p/send-tips02.png" alt="" style="width: 394px; margin-top: 42px;">
        <span style="font-size: 20px; margin: 12px 0px 32px;">{{ '메일 연동:' + bingdingEmail }}</span>
        <aside style="display: flex; justify-content: center; align-items: center;">
          <img src="@/assets/img/04p/config-btn.png" alt="" @click="sendGiftCode" style="height: 60px; margin-right: 25px;">
          <img src="@/assets/img/04p/close-btn.png" alt="" @click="showBindingGifPop2 = false" style="height: 60px; margin-left: 25px;">
        </aside>
      </section>
    </section>
    <audio id="audioHome" loop="loop">
      <source src="@/assets/img/01p/home.mp3" type="audio/mpeg">
    </audio>
  </section>
</template>

<style scoped>
.content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 60px; */
  height: 100%;
  background: url('../../assets/img/01p/xg-bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  position: relative;
}
img {
  display: block;
}
.side-left {
  position: absolute;
  left: 0;
  top: 2.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 0.42rem;
}
.side-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: url('../../assets/img/01p/side-r-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.16rem 0.12rem 0.32rem;
}
.yy-box {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
.out-box {
  background: rgb(139, 173, 216);
  position: absolute;
  right: 0.24rem;
  top: 1.2rem;
  height: 0.36rem;
  font-size: 0.18rem;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 6px;
  color: rgb(67, 116, 167);
  display: flex;
  align-items: center;
}
.audio-btn {
  position: absolute;
  right: 0.24rem;
  top: 1.78rem;
  color: rgb(67, 116, 167);
  display: flex;
  align-items: center;
  background: rgb(255 255 255 / 60%);
  padding: 6px;
  border-radius: 8px;
}
.out-btn {
  border-radius: 4px;
  border: none;
  background: none;
  color: #ffffff;
  font-size: 14px;
  padding: 3px 4px;
}
.out-btn:hover {
  background: rgb(255 165 0 / 60%);
}
.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask-content {
  width: 480px;
  height: 360px;
  background: url('../../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.jiantou {
  height: 0.72rem;
  animation: mouse 1s linear infinite both;
  transition: 0.3s;
}
@keyframes mouse {
  0% {
    margin-top: 0px;
  }
  50% {
    margin-top: 6px;
  }
  100% {
    margin-top: 0px;
  }
}
</style>
